export default __webpack_public_path__ + "static/media/d82a41ec31eea74dc36761400e02cb3c.fc18937f.svg";